const breakpoints = {
  xs: 0,
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1440,
  xxxl: 1900
};

export type Breakpoint = keyof typeof breakpoints;

export const mediaUp = (breakpoint: Breakpoint): string => `@media (min-width: ${breakpoints[breakpoint]}px)`;
